export const CACHE_KEY_LIST_ACTOR = 'actors';
export const CACHE_KEY_ACTOR = 'actor-one';
export const ROUTE_PATH_ACTOR = '/actors/configuration';
export const TRANSLATION_PREFIX_ACTOR = 'actors';
